import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class EducationPlatformService {
    public refreshLearningStatuses$: Subject<void> = new Subject<void>();

    constructor(private http: HttpClient) {}

    getRedirectUrl(userId: string, lang?: string): Observable<any> {
        return this.http.post<any>(
            `${environment.apiUrl}edu-platform/redirect-url`,
            { immosurance_admin_user_id: userId, lang: lang },
        );
    }

    getActiveCurricula(): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}edu-platform/curricula`,
        );
    }

    updateUserStatus(
        curriculumId: any,
        userId: string,
        isActive: boolean,
    ): Observable<any> {
        return this.http.put<any>(
            `${environment.apiUrl}edu-platform/curricula/${curriculumId}/users/status`,
            {
                immosurance_user_id: userId,
                is_active: isActive,
            },
        );
    }

    updateAllUserStatus(curriculumId: any, isActive: boolean): Observable<any> {
        return this.http.put<any>(
            `${environment.apiUrl}edu-platform/curricula/${curriculumId}/users/bulk-status`,
            {
                is_active: isActive,
            },
        );
    }

    getLearningStatuses(): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}edu-platform/learning-statuses`,
        );
    }

    startCurriculum(
        curriculumId: any,
        immosuranceUserId: string,
        lang?: string,
    ): Observable<any> {
        return this.http.post<any>(
            `${environment.apiUrl}edu-platform/curricula/${curriculumId}/start`,
            {
                immosurance_user_id: immosuranceUserId,
                lang: lang,
            },
        );
    }

    editCurriculum(
        curriculumId: any,
        immosuranceUserId: string,
        lang?: string,
    ): Observable<any> {
        return this.http.post<any>(
            `${environment.apiUrl}edu-platform/curricula/${curriculumId}/edit`,
            {
                immosurance_admin_user_id: immosuranceUserId,
                lang: lang,
            },
        );
    }

    /**
     * Get seat occupancy statistics for the current agency
     */
    getSeatStatistics(): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}edu-platform/seat-statistics`,
        );
    }

    /**
     * Check single user activation cost
     */
    checkUserActivationCost(
        curriculumId: any,
        userId: string,
    ): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}edu-platform/curricula/${curriculumId}/users/${userId}/check-activation-cost`,
        );
    }

    /**
     * Start eduction platform subscription checkout session
     */
    redirectToCheckoutSession(payload: any) {
        return this.http.post<any>(
            `${environment.apiUrl}edu-platform/redirect-to-checkout-session`,
            payload,
        );
    }

    /**
     * Get activation preview - shows where users will be allocated
     */
    getActivationPreview(
        curriculumId: string,
        userIds: string[],
    ): Observable<any> {
        return this.http.post<any>(
            `${environment.apiUrl}edu-platform/curricula/${curriculumId}/activation-preview`,
            { user_ids: userIds },
        );
    }

    /**
     * Bulk activate users with smart subscription allocation
     */
    bulkActivateUsers(
        curriculumId: string,
        userIds: string[],
    ): Observable<any> {
        return this.http.post<any>(
            `${environment.apiUrl}edu-platform/curricula/${curriculumId}/bulk-activate`,
            { user_ids: userIds },
        );
    }

    /**
     * Bulk deactivate users
     */
    bulkDeactivateUsers(
        curriculumId: string,
        userIds: string[],
    ): Observable<any> {
        return this.http.post<any>(
            `${environment.apiUrl}edu-platform/curricula/${curriculumId}/bulk-deactivate`,
            { user_ids: userIds },
        );
    }
}
